import { FaExclamationTriangle } from 'react-icons/fa';
import clsx from 'clsx';
import { confidenceBandChipBg } from '../lib/confidenceBand';

export function SuggestedCategory({
  documentCategory,
  suggestedCategory,
}: {
  documentCategory?: string | undefined | null;
  suggestedCategory: [string, number, number, number] | [string, number, number] | [string, number] | undefined;
}) {
  if (!suggestedCategory) {
    return undefined;
  }

  const [category, similarity] = suggestedCategory;

  return (
    <span className="flex items-center gap-2">
      {documentCategory && category !== documentCategory && (
        <span className="text-yellow-500 text-lg">
          <FaExclamationTriangle title={category} />
        </span>
      )}
      <span className={clsx('px-1.5 py-0.5 rounded-md text-xs whitespace-nowrap', confidenceBandChipBg(similarity))}>
        {(similarity * 100).toFixed(0)}%
      </span>
      {category}
    </span>
  );
}
